import { UseQueryResult, useQuery } from '@tanstack/react-query'
import Cookies from 'js-cookie'

import { ConditionsReportResponse } from '@nx/api'
import { createAuthenticatedAxiosClient } from '@nx/axios-client'

export function useGetConditionsReportParams(
  lotId: number,
  baseURL: string,
  enabled: boolean
): UseGetConditionsReportParamsReturn {
  const cookies = Cookies.get()

  const authenticatedAxiosClient = createAuthenticatedAxiosClient({
    accessTokenSSR: cookies?.bonhams_access || '',
    refreshTokenSSR: cookies?.bonhams_token || '',
    baseURL,
  })

  const { data, status, fetchStatus, error, refetch } = useQuery({
    queryKey: [
      'conditionsReport',
      lotId,
      `/api/auctions/condition-report/${lotId}/`,
    ],
    queryFn: async () => {
      try {
        const response = await authenticatedAxiosClient.get(
          `/api/auctions/condition-report/${lotId}/`,
          {
            headers: { Accept: 'application/pdf, text/plain, */*' },
          }
        )

        return response.data
      } catch {
        throw new Error('Failed to get conditions report')
      }
    },
    retry: 3,
    retryDelay: 1_000,
    enabled,
    refetchOnMount: false,
    refetchOnWindowFocus: false,
    refetchIntervalInBackground: false,
    refetchOnReconnect: false,
    retryOnMount: false,
  })

  return {
    data,
    status,
    fetchStatus,
    error,
    refetch,
  }
}

export interface UseGetConditionsReportParamsReturn
  extends Pick<UseQueryResult, 'status' | 'fetchStatus' | 'refetch'> {
  data?: ConditionsReportResponse
  error: Error | null
}
